export default __webpack_public_path__ + "assets/liam.4e7b9624.png";